<script>
import { mapState } from 'vuex'

import NavigationDrawer from './components/NavigationDrawer'

import { Plugins } from '@capacitor/core'
const { Browser } = Plugins

// const { App, Modals } = Plugins

import {
  GET_VIEWER_QUERY,
  IS_PROFILE_COMPLETED_QUERY
} from '@/graph/gql/user.gql'

export default {
  components: { NavigationDrawer },
  apollo: {
    _isProfileCompleted: {
      query: IS_PROFILE_COMPLETED_QUERY,
      fetchPolicy: 'cache-and-network',
      variables() {
        return { target: this.$isBuyer ? 'BUYER' : 'SELLER' }
      },
      skip() {
        return !this.authenticated
      },
      update: data => data.isProfileCompleted,
      result({ data }) {
        if (!data) return

        this.$store.commit('user/setProfileCompleted', data.isProfileCompleted)

        // Redirect to onboarding if the user has not completed the profile.
        if (data.isProfileCompleted === false /* && !this.$isBuyer*/) {
          const onboardPath = 'ProfileOnboardingView'
          if (this.$router.currentRoute.name !== onboardPath) {
            this.$router.replace({ name: onboardPath })
          }
        }
      }
    },
    user: {
      query: GET_VIEWER_QUERY,
      fetchPolicy: 'cache-first',
      update: data => data.viewer,
      skip() {
        return !this.authenticated
      }
    }
  },
  data() {
    return {
      orderSubmitted: null
    }
  },
  computed: {
    ...mapState('user', ['authenticated', 'isProfileCompleted'])
  },
  created() {
    /*
    App.addListener('appUrlOpen', async (data) => {
      let alertRet = await Modals.alert({
        title: 'Stop',
        message: JSON.stringify(data)
      })
      if (data.url.startsWith('com.pona.app')) {
        this.$router.push('/callback' + data.url.split('callback').pop())
      }
    })
    */
  },
  methods: {
    // Open help page
    openHelp() {
      Browser.open({ url: 'https://www.pona.app/faq' })
    },

    // Close rating venue card
    closeRatingCard() {
      this.orderSubmitted = null
    },

    // Order was created
    handleSubmittedOrder(event) {
      this.orderSubmitted = event
    },

    // Drawer was opened
    openDrawer() {
      if (this.$refs.drawer) {
        this.$refs.drawer.drawer = true
      }
    }
  },
  metaInfo: {
    title: 'Home cooked food, without the hassle',
    titleTemplate: '%s | Pona',
    meta: [
      {
        name: 'description',
        content:
          'Order one-of-a-kind meals prepared with love by home cooks in Kuala Lumpur and Petaling Jaya.'
      }
    ]
  }
}
</script>

<template>
  <v-app id="app">
    <NavigationDrawer ref="drawer" :user="user" />
    <router-view name="navigation" @openDrawer="openDrawer" />
    <v-content class="pt-0">
      <v-container class="pa-0">
        <router-view
          :user="user"
          @closeRatingCard="closeRatingCard"
          @submitOrder="handleSubmittedOrder"
          @openDrawer="openDrawer"
        />
      </v-container>
    </v-content>

    <v-footer v-if="user && isProfileCompleted" app padless fixed>
      <router-link
        v-if="
          $isSeller &&
            user.sellerProductsCount === 0 &&
            user.sellerStatus !== 'SUSPENDED'
        "
        :to="{ name: 'MenuView' }"
      >
        <v-alert text="" color="accent">
          <v-icon color="accent" size="20" class="mr-2"
            >$vuetify.icons.clipboardList</v-icon
          >Add your first menu to proceed.
        </v-alert>
      </router-link>
      <div
        v-if="
          $isSeller &&
            user.sellerStatus === 'PENDING' &&
            user.sellerProductsCount > 0
        "
        @click="openHelp"
      >
        <v-alert text="" color="primary">
          <v-icon color="primary" size="20" class="mr-2"
            >$vuetify.icons.clipboardCheck</v-icon
          >Your application is under review.
        </v-alert>
      </div>
      <div
        v-if="$isSeller && user.sellerStatus === 'SUSPENDED'"
        @click="openHelp"
      >
        <v-alert text="" color="accent">
          <v-icon color="accent" size="20" class="mr-2"
            >$vuetify.icons.lock</v-icon
          >Your account is suspended.
        </v-alert>
      </div>
      <router-link
        v-if="
          $isSeller &&
            user.sellerStatus === 'ACTIVE' &&
            user.sellerSchedule.status === 'PAUSED'
        "
        :to="{ name: 'ScheduleView' }"
      >
        <v-alert text="" color="secondary">
          <v-icon color="secondary" size="20" class="mr-2"
            >$vuetify.icons.pauseCircle</v-icon
          >You're taking a break (profile hidden).
        </v-alert>
      </router-link>
    </v-footer>
  </v-app>
</template>

<style lang="sass">
$body-font-family: 'Inter', sans-serif
$heading-font-family: 'MetropolisBold', sans-serif
$subheading-font-family: 'MetropolisMedium', sans-serif

@import '~vuetify/src/styles/main.sass'
@import url('https://rsms.me/inter/inter.css')
@import url('https://fontlibrary.org/face/metropolis')

html, .v-application
  font-family: 'Inter', sans-serif !important
@supports (font-variation-settings: normal)
  html, .v-application
    font-family: 'Inter var', sans-serif !important

.v-application
  user-select: none
  .display-1
    font-family: $heading-font-family !important
  .title, .subheading
    font-family: $subheading-font-family !important

.v-toolbar__title
  font-family: $body-font-family !important
  font-size: 1.1rem
  font-weight: 500

.v-application.theme--light, .v-application.theme--light.v-application
  background: #fff

// .v-label
//   color: #607D8B !important

.v-toolbar
  &:not(.v-toolbar--bottom) .v-toolbar__content
    border-bottom: 1.5px solid transparent
  &.v-toolbar--bottom .v-toolbar__content
    border-top: 1px solid #eee
  &.v-app-bar--is-scrolled .v-toolbar__content
    border-color: #eee

.v-btn
  box-sizing: border-box
  letter-spacing: unset !important
  .v-btn__content
    text-transform: none

.v-btn--outlined,
.v-text-field:not(.v-input--has-state) > .v-input__control > .v-input__slot:before
  border-color: #E0E0E0 !important

.v-text-field > .v-input__control > .v-input__slot:before
  border-width: 2px 0 0 0

.v-btn--outlined,
.v-chip
  border-width: 2px !important
  border-style: solid

.v-btn.primary:not(.v-btn--outlined)
  border: 1px solid #00bcb5 !important

.v-card__actions .v-btn.v-btn
  padding: 0 16px

.theme--light.v-divider
  border-color: rgba(0, 0, 0, 0.08)

.v-date-picker-header .v-icon,
.v-select__slot .v-icon.fa-caret-down
  font-size: 16px !important

.v-select__selections .v-chip--select:first-child
  margin-left: 0

.v-chip--select.v-size--small .v-chip__close.v-icon
  margin-right: -7px !important
  font-size: 14px

.v-skeleton-loader__list-item-avatar-two-line, .v-skeleton-loader__heading, .v-skeleton-loader__paragraph
  padding-left: 0 !important
  margin-left: 0 !important
  padding-right: 0 !important
  margin-right: 0 !important

.pac-container
  margin-bottom: 16px

.container
  height: 100%

.v-footer
  & > div, & > a
    text-decoration: none
    display: flex
    width: 100%
  .v-alert
    width: 100%
    margin-bottom: 0 !important

/* View grid */
.view-grid
  height: 100%
  display: grid
  grid-template-rows: auto auto
  grid-template-columns: minmax(0, 1fr)
  grid-template-areas: "top" "bottom"
  & > div
    padding: 8px 20px
    @media only screen and (max-device-width: 960px)
      width: 100vw
  .content-top
    grid-area: top
  .content-bottom
    padding-bottom: 20px
    grid-area: bottom
    align-self: end

/* Router transitions */
.fade-enter-active, .fade-leave-active
  transition: opacity .5s

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
  opacity: 0

.slide-up-enter-active
  transition: all .3s ease

.slide-up-enter
  transform: translateY(50px)
  opacity: 0

.slide-right-enter-active
  transition: all .3s ease

.slide-right-enter
  transform: translatex(20px)
  opacity: 0

/* Component transitions */
.slide-leave-active,
.slide-enter-active
  transition: 1s
.slide-enter
  transform: translate(100%, 0)
.slide-leave-to
  transform: translate(-100%, 0)
</style>
